import AppWrapper from "../../components/cm/AppWrapper";
import FollowUpCalendar from "../../components/cm/Dashboard/FullPages/ClientDetail/FollowUps/Calendar";
import SideBarMain from "../../components/cm/SideBarMain";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <FollowUpCalendar />
    </AppWrapper.WithSidebar>
  );
};
